module.exports = "/images/role-consultant-agency-icon.svg?98cfcc726c9d774b99dcbe8166980765";